export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',	
        iconStyle: <i className="flaticon-381-networking"></i>,
        to: '/dashboard',
    },

    {
        title: 'KYC List',	
        iconStyle: <i className="flaticon-381-id-card-5"></i>,
        content: [
            {
                title: 'Add KYC',
                to: '/kyc-settings/add-kyc'
            },
            {
                title: 'Manage KYC List',
                to: '/kyc-settings'
            }
           
        ]
    },

    {
        title: 'Settings',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-settings-1"></i>,
        content: [
            {
                title: 'Transaction Settings',
                to: '/transaction-settings'
            },
            {
                title: 'Merchant Settings',
                to: '/merchant-settings'
            },
            {
                title: 'API Settings',
                to: '/access-key-settings'
            },
        ]
    },

    {
        title: 'Merchants',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-user-1"></i>,
        content: [
            {
                title: 'Add Merchants',
                to: '/merchants/create'
            },
            {
                title: 'Manage Merchants',
                to: '/merchants'
            },
        ]
    },
    {
        title: 'Merchant IPs',	
        iconStyle: <i className="flaticon-381-padlock-2"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add IPs',
                to: '/ip-whitelisted/create'
            },
            {
                title: 'Manage IPs',
                to: '/ip-whitelisted'
            },
        ]
    },
    {
        title: 'Fund Requests',	
        iconStyle: <i className="flaticon-381-id-card"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Create Fund Requests',
                to: '/fund-requests/create'
            },
            {
                title: 'Manage Fund Requests',
                to: '/fund-requests'
            },
        ]
    },

    {
        title: 'Debit Funds',	
        iconStyle: <i className="flaticon-381-id-card"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Create Debit',
                to: '/debit-funds/create'
            },
            {
                title: 'Manage Debits',
                to: '/debit-funds'
            },
        ]
    },
    
    {
        title: 'Transactions',	
        iconStyle: <i className="flaticon-381-list"></i>,
        to: '/transactions',
    },
   {
        title: 'Reports',	
        iconStyle: <i className="flaticon-381-network"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Fund Requests',
                to: '/reports/fund-requests'
            },
            {
                title: 'Payouts',
                to: '/reports/payout'
            },
            {
                title: 'Merchant Invoices',
                to: '/reports/merchant-invoices'
            }
        ]
    },
    {
        title: 'Application Messages',
        iconStyle: <i className="flaticon-381-notification"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add Message',
                to: '/add-application-message'
            },
            {
                title: 'Manage Messages',
                to: '/application-messages'
            },
        ]
    },
    {
        title: 'Process Statement',
        iconStyle: <i className="flaticon-381-file-1"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Upload Statement',
                to: '/process-statement/upload'
            },
            {
                title: 'Statement Files',
                to: '/process-statement'
            },
            {
                title: 'Statement Records',
                to: '/process-statement/records'
            },
            {
                title: 'Reprocess Logs',
                to: '/process-statement/reprocess-logs'
            },
        ]
    }
]